export const SIGN_IN_SUCCESS = 'src/auth/signin/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'src/auth/signin/SIGN_IN_FAILURE';
export const SIGN_OUT_SUCCESS = 'src/auth/signout/SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'src/auth/signout/SIGN_OUT_FAILURE';
export const CLEAR_MESSAGE = 'src/auth/CLEAR_MESSAGE';
export const SET_ERROR_MESSAGE = 'src/auth/SET_ERROR_MESSAGE';
